import AbstractApi from '@/api/abstracts/AbstractApi'
import httpClient from '@/utilities/service/httpClient'
// Types
import { CostingsHistoryAllType, CostingsHistoryType } from '@/api/types/response/CostingsHistoryType'

/**
 * @property string apiEnd /api/sales/bid/cost/history/{BidNumber}
 */
export default class CostingsHistoryApi extends AbstractApi {
  detail(record: number): Promise<CostingsHistoryType> {
    const url = this.apiEnd + (!isNaN(record) ? `/${record}` : '')
    return httpClient.get(url)
  }

  all(): Promise<CostingsHistoryAllType> {
    return httpClient.get(`${this.apiEnd}/all`)
  }
}
